import { useEffect, useState } from "react";
import HostApi from "../../../../../data/settings/HostApi";
import { contentCarousel2LandingPage, contentCarouselLandingPage } from "./constants";
import "./landingPage.scss";
import CarImplDto from "../../../../../data/dto/impl/CarImplDto";
import CarEntity from "../../../../../domain/entities/CarEntity";
import CarCardComponent from "../../../components/carCard/CarCardComponent";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { API_URL, GOOGLE_MAPS_API_KEY } from "../../../../../config/env";
function LadingPage() {
    const ids = [1785, 1858, 1766, 1752, 1670, 1566, 1772, 1539, 1828, 1824, 1831];
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [cars, setCars] = useState({
        cars: [],
        maxPages: 0,
        count: 0,
    });

    const mapContainerStyle = {
        width: "98%",
        height: "96px",
    };

    const location1 = {
        lat: 4.691959880308249,
        lng: -74.07611493603319,
    };
    const location2 = {
        lat: 4.902005263873653,
        lng: -74.03039745767153,
    };
    const location3 = {
        lat: 4.691388319180716,
        lng: -74.07598815868705,
    };
    const location4 = {
        lat: 4.691667638838912,
        lng: -74.07556760447528,
    };
    const center = {
        lat: (location1.lat + location2.lat) / 2,
        lng: (location1.lng + location2.lng) / 2,
    };

    useEffect(() => {
        const fetchAllCars = async () => {
            try {
                const carPromises = ids.map((id) =>
                    fetch(`${API_URL}/cars/${id}`).then((response) => {
                        if (!response.ok) {
                            throw new Error(`Error en la petición para el ID ${id}: ${response.statusText}`);
                        }
                        return response.json();
                    }),
                );

                const allCars = await Promise.all(carPromises);
                setCars({
                    cars: allCars
                        .map((car: any) => CarImplDto.fromJson(car))
                        .filter((car: CarEntity) => car.id != "19"),
                    maxPages: 1,
                    count: allCars.length,
                });
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchAllCars();
    }, []);

    useEffect(() => {
        // Script principal con los parámetros de la nueva forma
        const scriptContent = `
            !function(a,m,o,c,r,m){
                a[o+c]=a[o+c]||{setMeta:function(p){this.params=(this.params||[]).concat([p])}},
                a[o+r]=a[o+r]||function(f){a[o+r].f=(a[o+r].f||[]).concat([f])},
                a[o+r]({id:"1546744",hash:"eb88c5579afdff15cf6c5a2785416a7e",locale:"es"}),
                a[o+m]=a[o+m]||function(f,k){a[o+m].f=(a[o+m].f||[]).concat([[f,k]])}
            }(window,0,"amo_forms_","params","load","loaded");
        `;

        const script = document.createElement("script");
        script.async = true;
        script.innerHTML = scriptContent;
        document.body.appendChild(script);

        // Segundo script que carga la funcionalidad del formulario
        const kommoScript = document.createElement("script");
        kommoScript.id = "amoforms_script_1546744";
        kommoScript.async = true;
        kommoScript.src = "https://forms.kommo.com/forms/assets/js/amoforms.js?1755721688";

        // Añade el segundo script después de un breve retraso
        setTimeout(() => {
            document.getElementById("kommo-form-container1")?.appendChild(kommoScript);
        }, 1000);

        // Función de limpieza para eliminar los scripts cuando el componente se desmonta
        return () => {
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
            const formContainer = document.getElementById("kommo-form-container");
            if (formContainer && formContainer.contains(kommoScript)) {
                formContainer.removeChild(kommoScript);
            }
        };
    }, []);

    return (
        <div className="layout_container">
            <section className="container-landing phone-header ">
                <img src="/assets/logos/horizontal-white.svg" alt="" className="logo-wcar" />
                <h1 className="side side_top wcar-absolute text-wcar">wcar</h1>
                <h1 className="text-light text-landing">
                    Carros usados de
                    <br />
                    alta gama
                    <h3 className="text-2 text_italic">Listos para ti</h3>
                </h1>

                <img src="/assets/landing/background.webp" alt="" className="image-background" />
                <img src="/assets/landing/car-landing.webp" alt="" className="car-background" />
                {/* <div className="container-form">
                    <span className="text-form side side_top">
                        Formulario de{" "}
                        <span
                            className="text_orange text_italic title_orange text-header-italic"
                            style={{
                                fontWeight: "500",
                            }}
                        >
                            contacto
                        </span>
                    </span>
                    <div id="kommo-form-container1" style={{ textAlign: "center" }}></div>
                </div> */}
            </section>
            {/* <section className="container-landing ">
                <div className="container-header-desk">
                    <img src="/assets/logos/horizontal-white.svg" alt="" className="logo-wcar" />
                    <h1 className="side side_top wcar-absolute text-wcar">wcar</h1>
                    <h1 className="text-light text-landing">
                        Carros usados de
                        <br />
                        alta gama
                        <h3 className="text-2 text_italic">Listos para ti</h3>
                    </h1>

                    <img src="/assets/landing/background.webp" alt="" className="image-background" />
                    <img src="/assets/landing/car-landing.webp" alt="" className="car-background" />
                </div>
                <div className="container-form">
                    <span className="text-form side side_top">
                        Formulario de{" "}
                        <span
                            className="text_orange text_italic title_orange text-header-italic"
                            style={{
                                fontWeight: "500",
                            }}
                        >
                            contacto
                        </span>
                    </span>
                    <div id="kommo-form-container1" style={{ textAlign: "center" }}></div>
                </div>
            </section> */}

            <section className="section-2-landing">
                <span className="side side_top wcar-absolute text-section-2">Vehículos usados en Bogotá con</span>
                <span className={"text2-section-2"}>peritaje certificado y garantía</span>
                <div className="container-carousel">
                    {contentCarouselLandingPage.map((item) => (
                        <div className="container-item-carousel">
                            <img className="icon-item-carousel" src={item.imageUrl} alt="" />
                            <p className="text-item-carousel">{item.text}</p>
                        </div>
                    ))}
                </div>
            </section>
            <section className="section-form">
                <div className="container-form">
                    <span className="text-form side side_top text-section-2">
                        Formulario de{" "}
                        <span
                            className="text_orange text_italic title_orange text-header-italic"
                            style={{
                                fontWeight: "500",
                            }}
                        >
                            contacto
                        </span>
                    </span>
                    <div id="kommo-form-container1" style={{ textAlign: "center" }}></div>
                </div>
            </section>
            <section className="section-3">
                <div className="container-text-section-3">
                    <span className=" side side_top text-section-3" style={{ color: "black", fontWeight: 700 }}>
                        Vehículos{" "}
                        <span
                            className="text_orange text_italic title_orange text-header-italic"
                            style={{
                                fontWeight: "500",
                            }}
                        >
                            en venta
                        </span>
                    </span>
                    <div className="row row-cols-1 row-cols-md-3 g-4 mt-2 justify-content-center">
                        {cars != undefined &&
                            cars.cars.length > 0 &&
                            cars.cars.map((car, index) => {
                                return (
                                    <>
                                        <div className={""} style={{ width: 400 }} key={car.id}>
                                            <CarCardComponent car={car} />
                                        </div>
                                    </>
                                );
                            })}
                    </div>
                </div>
            </section>
            <section className="section-4">
                <span className=" wcar-absolute text-section-4 text-center">Autos usados con peritaje</span>
                <span className={"text2-section-4 text-center"}>tu inversión segura</span>
                <p className="text-section4">
                    Comprar un carro usado es una inversión. Por eso garantizamos que cada vehículo cuenta con:
                </p>

                <div className="div-container-carousel-2">
                    {contentCarousel2LandingPage.map((item) => (
                        <div className="item-carousel-2">
                            <img src={item.imageUrl} alt="" className="icon-item-carousel-2" />
                            <p className="text-item-carousel-2">
                                {item.text}
                                <br />
                                <span className="text_orange">{item.textOrange}</span>
                            </p>
                        </div>
                    ))}
                </div>
            </section>
            <footer className="footer">
                <div className="top-footer">
                    <div>
                        <img src="/assets/logos/horizontal-white.svg" alt="" className="logo-wcar-footer" />
                        <p className="text-light">Más que vender, te aconsejamos.</p>
                    </div>
                    <div className="container-map-footer">
                        <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
                            <GoogleMap mapContainerStyle={mapContainerStyle} center={center} zoom={9}>
                                <Marker position={location1} />
                                <Marker position={location4} />
                                <Marker position={location2} />
                                <Marker position={location3} />
                            </GoogleMap>
                        </LoadScript>
                    </div>
                </div>
                <div className="bottom-footer">
                    <img className="m-auto" src="/assets/landing/industria&comercio.svg" alt="" />
                    <p className="text-footer text-center mt-4 pb-4">wcar - Todos los derechos reservados © 2024</p>
                </div>
            </footer>
        </div>
    );
}

export default LadingPage;
